
  import { Vue, Component, Prop } from "vue-property-decorator";
  import CardSingleChip from "@/components/card/CardSingleChip.vue";
  import CardBodyItem from "@/components/card/CardBodyItem.vue";
  import ItemChipsData from "@/entities/ItemChipsData";

  @Component({
    components: {
      CardBodyItem,
      CardSingleChip,
    },
  })
  export default class CardBodySingleChip extends Vue {
    @Prop({ type: String, required: true }) readonly label!: string;
    @Prop({ type: Object, required: true }) readonly chipDetails!: ItemChipsData;
    @Prop({ type: Boolean, default: false }) readonly wide!: boolean;
    @Prop({ type: Boolean, default: false }) readonly withAvatar!: boolean;
  }
